import {toast, ToastOptions} from 'react-toastify'

export function notifySuccess(message: string | React.ReactNode, options?: ToastOptions) {
  toast.success(message, options)
}

export function notifyError(message: string | React.ReactNode) {
  toast.error(message)
}
